export class DepartmentResult {
    public id: number = 0;
    public name: string = '';
    public securityLevel: string = '';
    public isDeleted: boolean = false;
}
